// extracted by mini-css-extract-plugin
export default {"container":"styles_container__uHTQZ","count":"styles_count__iXUto"};